export default "__VITE_ASSET__Cq8g_nHj__"